import { Flex, Skeleton } from "antd";

export default function CourseDetailsHeaderLoading() {
  return (
    <>
      <Skeleton.Input
        active
        className="mt-5 mb-9 !h-6 !w-[600px]"
        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
      />
      <div>
        <Skeleton.Input
          active
          className="!h-6 !w-48"
          style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
        />

        <Flex align="center" gap={16} wrap className="mt-4">
          <Skeleton.Button
            active
            className="!h-6 !w-32"
            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
          />
          <Skeleton.Button
            active
            className="!h-6 !w-32"
            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
          />
          <Skeleton.Button
            active
            className="!h-6 !w-48"
            style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
          />
        </Flex>
      </div>
    </>
  );
}
